/** Canonical browser storage keys for the P-1 auth persistence stack. */
export const USER_INFO_KEY = 'userInfo';
